<template>
    <div>
        <div class="my bg_eef1fa web_my">
            <div class="main bg_fff">
                <div class="my_username flex_start align_items_center">
                    <div class="my_username_avatar">
                        <img :src="avatar" />
                        <input type="file" @change="upData($event)" ref="InputFile" name="files" />
                    </div>
                    <p>{{username}}</p>
                </div>
                <div class="my_history">
                    <div class="my_history_tab flex_start align_items_center">
                        <span :class="type == 1 ? 'on' : ''" @click="listChange(1,1)">点赞</span>
                        <span :class="type == 2 ? 'on' : ''" @click="listChange(2,1)">下载</span>
                        <span :class="type == 3 ? 'on' : ''" @click="listChange(3,1)">收藏</span>
                    </div>
                    <div class="box">
                        <div class="list flex_start" v-for="(item,index) in datalist" @click="goUrl(this,item.article.id,item.article.type)" v-if="item.article">
                            <div class="list_img">
                                <img :src="item.article.pic" />
                            </div>
                            <div class="web_list_text flex_space_between">
                                <h2><i>【{{item.type_text}}】</i>{{item.article.title}}</h2>
                                <p class="flex_end">
                                    <span>{{item.article.source}}</span>
                                    <span>{{item.create_time}}</span>
                                </p>
                            </div>
                        </div>
                        <div class="list flex_start"  v-else>该内容不存在</div>
                    </div>
                </div>
            </div>

            <div class="page" v-html="page_html">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "index",
        data () {
            return {
                username: '',
                avatar: '',
                type: 1,
                datalist: [],
                page:1,
                page_html:'',
            }
        },
        created() {
            let _this = this;
            if(!localStorage.getItem('user_token')){
                layer.msg('请先登录，正在为您跳转，请稍后。。。');
                setTimeout(function () {
                    _this.$router.push({
                        path: '/my/login'
                    })
                },1500);
            }
            _this.username = localStorage.getItem('user_username');
            _this.avatar = localStorage.getItem('user_avatar');
            if(_this.$route.query.page) {
                _this.page = _this.$route.query.page;
            }
            if(_this.$route.query.type) {
                _this.type = _this.$route.query.type;
            }
            _this.listChange(_this.type,_this.page);
        },
        mounted() {
        },
        methods: {
            listChange: function (type,page) {
                console.log(type)
                console.log(page)
                let _this = this,
                    token = localStorage.getItem('user_token');
                _this.type = type;
                this.$http({
                    url: 'my/index',
                    method: 'post',
                    headers: {"Content-Type": "multipart/form-data"},
                    data:{token:token,type:type,page:page}
                }).then(res => {
                    if(res.data.code == 1) {
                        _this.datalist = res.data.data.list;
                        _this.page_html = res.data.data.page;
                        _this.type = res.data.data.type;
                    } else {
                        layer.msg(res.data.msg);
                    }
                });
            },
            goUrl: function (obj,id,type) {
                this.$router.push({
                    path: '/' + type + '/detail',
                    query: {
                        id: id
                    }
                })
            },
            upData(event) {
                var reader = new FileReader();
                let fileData = this.$refs.InputFile.files[0];
                reader.readAsDataURL(fileData);
                let _this = this;
                reader.onload = function(e) {
                    //这里的数据可以使本地图片显示到页面
                    // _this.avatar = e.srcElement.result;
                };
                // 使用formapi打包
                let formData = new FormData();
                formData.append('file', fileData);
                formData.append('token', localStorage.getItem('user_token'));
                _this.$http({
                    url: 'index/upload',
                    method: 'post',
                    headers: {"Content-Type": "multipart/form-data"},
                    data:formData
                }).then(res => {
                    if(res.data.code != 1)
                    {
                        window.location.reload();
                    } else {
                        _this.avatar = res.data.data.fullurl;
                        localStorage.setItem('user_avatar',res.data.data.fullurl)
                    }
                });
            },
        }
    }
</script>

<style scoped>
    .my{padding:10px 0 100px;}
    .my .main{padding:30px 55px;}
    .my_username {width: 100%;font-size:30px;color:#000;line-height: 87px;}

    .my_username img,.my_username_avatar{width: 87px;height: 87px;object-fit: cover;border-radius: 50%;overflow: hidden;display: block;margin-right: 30px;}

    .my_username_avatar{position: relative;}
    .my_username_avatar input[type=file]{width:100%;height: 100%;position: absolute;top:0;right:0;bottom:0;left:0;opacity: 0;}

    .my_history{display: block;margin-left:105px;margin-top:55px;width: 820px;}
    .my_history_tab{width: 100%;margin-bottom: 35px;}
    .my_history_tab span,.my_history_tab a{width: auto;font-size:30px;color:#666;line-height: 54px;border-bottom: 3px solid #fff;padding:0 10px;display: block;margin-right: 42px;}
    .my_history_tab span.on, .my_history_tab a.on{color:#5e8dee;border-color: #5e8dee;}
    .box,.list{width: 100%;display: block;padding:20px 0;}
    .list a{width: 100%;padding:20px 0;border-bottom: 1px solid #e6e6e6;}
    .list_img,.list_img img{width: 120px;height: 120px;min-width:120px;object-fit: cover;display: block;overflow: hidden;transition: all ease .5s;border-radius: 10px;margin-right: 15px;}
    .list:hover .list_img img{transform: scale(1.05);}
    .list h2{width:320px;font-size:20px;line-height: 28px;color:#333;font-weight: normal;display: block;}
    .list p{flex-grow: 1;width: calc(100% - 455px);padding-left:15px;}
    .list p span{font-size:14px;line-height: 21px;color:#666;display: block;margin-left:35px;}
    .page{max-width: 1200px;margin:35px auto;}

    .list h2 i{font-style: normal;color:#c1000e;}
    .web_list_text{flex-grow: 1;}
    @media screen and (max-width: 1240px) {
        .web_my{padding:2% 2% 8.0645vw;}
        .web_my.my .main{padding:2.419vw 4.435vw;}
        .web_my .my_history{width: 90%;margin:4.435vw auto 0;}
        .my_history_tab{margin-bottom: 2.8225vw;}
        .my_history_tab span{font-size:2.419vw;line-height: 4.3548vw;margin-right: 3.387vw;}
        .list p span{white-space: nowrap;margin-left:20px;}
        .list h2{flex-grow: 1;width: auto;}
        .list p{padding-left:0;width: auto;}
    }
    @media screen and (max-width: 750px) {
        .web_list_text{flex-wrap: wrap;}
        .my_history_tab span{font-size:18px;line-height: 36px;margin-right: 20px;}
        .list h2{width:100%;font-size:16px;line-height: 24px;}
        .list p span{height: 21px;}
    }
</style>



// WEBPACK FOOTER //
// src/pages/my/index.vue